import { render, staticRenderFns } from "./workManage.vue?vue&type=template&id=511b8ca4&scoped=true&style=height%3A%20100%25%3B&"
import script from "./workManage.vue?vue&type=script&lang=js&"
export * from "./workManage.vue?vue&type=script&lang=js&"
import style0 from "./workManage.vue?vue&type=style&index=0&id=511b8ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511b8ca4",
  null
  
)

export default component.exports